import DataRow from './DataRow'
import { useIsPivot, useRows } from './utils/TableStore'

function RowList<T extends Record<string, unknown>>() {
  const pivot = useIsPivot()
  const rows = useRows<T>()
  return (
    <>
      {rows.map((id, i) => (
        <DataRow key={id} rowId={id} pivot={pivot} index={i} />
      ))}
    </>
  )
}

export default RowList
